import { CAlert } from "@coreui/react";
import { useSelector } from "react-redux";

import SystemNotification, {
  NOTIFICATION_LEVEL_DANGER,
  NOTIFICATION_LEVEL_INFO,
  NOTIFICATION_LEVEL_WARNING,
} from "../../models/system-notification";
import { RootState } from "../../store";

const LEVEL_COLORS: Map<string, string> = new Map([
  [NOTIFICATION_LEVEL_INFO, "info"],
  [NOTIFICATION_LEVEL_WARNING, "warning"],
  [NOTIFICATION_LEVEL_DANGER, "danger"],
]);

const LEVEL_ICONS: Map<string, string> = new Map([
  [NOTIFICATION_LEVEL_INFO, "fa fa-info-circle"],
  [NOTIFICATION_LEVEL_WARNING, "fa fa-exclamation-triangle"],
  [NOTIFICATION_LEVEL_DANGER, "fa fa-exclamation-circle"],
]);

const getColor = (notification: SystemNotification) =>
  LEVEL_COLORS.get(notification.level ?? NOTIFICATION_LEVEL_INFO) ?? "info";

const getIcon = (notification: SystemNotification) =>
  LEVEL_ICONS.get(notification.level ?? NOTIFICATION_LEVEL_INFO) ??
  "fa fa-info-circle";

/**
 * Renders every active notification, most severe first, stacked one below the
 * other. The list comes from SystemNotificationsProvider, already ordered by
 * the backend.
 */
const SystemNotificationBanners: React.FunctionComponent = () => {
  const notifications = useSelector(
    (state: RootState) => state.systemNotifications.items
  );

  if (notifications.length === 0) {
    return null;
  }

  // Sits between the card header and the card body, which has no padding of
  // its own at that point, hence the wrapper.
  return (
    <div className="px-3 pt-3">
      {notifications.map((notification) => (
        <CAlert
          key={notification.id}
          color={getColor(notification)}
          className="d-flex align-items-center mb-2"
        >
          <i className={`${getIcon(notification)} mr-2 flex-shrink-0`} />
          <span>
            {notification.title && <strong>{notification.title}: </strong>}
            {notification.description}
          </span>
        </CAlert>
      ))}
    </div>
  );
};

export default SystemNotificationBanners;
